import { favoritesFetched, requestStarted } from '../Actions';
import FavoriteFetch from '../../../fetch/FavoriteFetch';
import { reportError } from './AppErrorThunk';

export function fetchFavorites(callback = null) {
  return function (dispatch) {
    dispatch(requestStarted());

    // In a real world app, you also want to
    // catch any error in the network call.
    return FavoriteFetch.getAll()
      .then((json) => dispatch(favoritesFetched(json)))
      .then(
        (json) =>
          // We can dispatch many times!
          // Here, we update the app state with the results of the API call.

          callback && dispatch(callback)
      )
      .catch((error) => {
        dispatch(reportError(error));
      });
  };
}
